import { DMI } from './dmi';
import './svg-srite';


document.addEventListener('DOMContentLoaded', () => {
    DMI.importAll();

    document.body.classList.add('is-ready');

    window.addEventListener('popstate', ({ state }) => {
        if (state && state.reload) {
            window.location.reload();
        }
    });
});